import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ApiService } from '../api.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Headers, RequestOptions } from '@angular/http';
import { PanelAssign } from 'src/app/model/panel-assign-model/panel-assign.model';
import { SubmitPanelAssign } from 'src/app/model/panel-assign-model/submit-panel-assign.model';
import { Panel } from 'src/app/model/panel-modal/panel-model';


@Injectable({
  providedIn: 'root'
})
export class PanelAsignService {

  constructor(private http: Http, private apiService: ApiService) { }
  private apiDomain = ApiService.getDomainName();

  form: FormGroup = new FormGroup({
    id: new FormControl(null),
    candidateId: new FormControl(''),
    panelId: new FormControl(''),
    status: new FormControl('', Validators.required),
    feedback: new FormControl('', Validators.required),
  });
  private handleError(error: any) {
    console.error('An error occurred', error);
    try {
      const errorJSON = error && error.json();
      if ( errorJSON.httpCode == 401 ) {
        ApiService.sessionExpireRedirection();
      }
      return Promise.reject(errorJSON);
    } catch(err) {
      return Promise.reject(error && error.message);
    }
  }

  verifyPanelMemberSession(sessionId: String | null) {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    return this.http.get(`${this.apiDomain}/ims/api/getPanelMemberSessionData?sessionId=${sessionId}`, { headers })
      .toPromise()
      .then(response => response && response.json())
      .catch(this.handleError);
  }

   updateAttendance(jsonObject: any, panelId) {
    let panelAssignHeaders = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.put(this.apiDomain + "/ims/api/panel/" + panelId + "/attendance", jsonObject, { headers: panelAssignHeaders })
      .toPromise()
      .then(response => (response && (<any>response)._body))  //response._body
      .catch(this.handleError);
  }

  completeFeedback(jsonObject: any, panelId): Promise<Array<PanelAssign>> {
    let panelAssignHeaders = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.put(this.apiDomain + "/ims/api/panel/" + panelId + "/completeFeedback", jsonObject, { headers: panelAssignHeaders })
      .toPromise()
      .then(response => response.status as any) 
      .catch(this.handleError);
  }

  updateStatus(jsonObject: any, panelId): Promise<Array<PanelAssign>> {
    let feedbackHeaders = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.put(this.apiDomain + "/ims/api/panel/" + panelId + "/feedback", jsonObject, { headers: feedbackHeaders })
      .toPromise()
      .then(response => response.status as any)
      .catch(this.handleError);
  }

  updateFeedback(submitPanelAssign: SubmitPanelAssign, panelId): Promise<Array<SubmitPanelAssign>> {
    let submitPanelAssignHeaders = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.put(this.apiDomain + "/ims/api/panel/" + panelId + "/feedback", submitPanelAssign, { headers: submitPanelAssignHeaders })
      .toPromise()
      .then(response => response.json() as any)
      .catch(this.handleError);
  }
  getPanelCandidate(panelId) {
    const headers = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.get(this.apiDomain + "/ims/api/" + panelId + "/panelCandidate", { headers })
      .toPromise()
      .then(response => response.json() as Panel[])
      .catch(this.handleError);

  }

  getPanelPanelMember(panelId) {
    const headers = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.get(this.apiDomain + "/ims/api/" + panelId + "/panelPanelMember", { headers })
      .toPromise()
      .then(response => response.json() as Panel[])
      .catch(this.handleError);

  }

}